<template>
    <div class="step-prev" :class="{ 'no-count': noCount }">
        <button @click.prevent="prev" v-html="$icon('prev')"></button>
    </div>
</template>

<script>
export default {
    name: "step-prev",
    props: ["noCount"],
    methods: {
        prev() {
            this.$emit("prev");
        }
    }
};
</script>

<style lang="scss">
.step-prev {
    position: relative;
    // padding-top: 54px;

    &.no-count {
        position: absolute;
        z-index: 500;
    }

    @media all and (max-width: $mobile) {
        display: none;
    }

    button {
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
        margin: 0;
        padding: 0;
    }
}
</style>
